import request from "./api";
//==============================数据中心======================================
// 查询在线访问数
export const getOnlineVisitsNum = (deptId, params, opts) => request(`/api-data/online/visit/count/get/${deptId}`, params, opts)
// 查询平台访问数
export const getPlatformVisitsNum = (deptId, params, opts) => request(`/api-data/visit/count/get/${deptId}`, params, opts);
// 查询学生入学年份分布
export const getEnrollmentYear = (deptId, params, opts) => request(`/api-data/user/year/count/get/${deptId}`, params, opts);
// 查询学生性别分布
export const getGender = (deptId, params, opts) => request(`/api-data/user/sex/count/get/${deptId}`, params, opts);
// 查询学生省份分布
export const getProvince = (deptId, params, opts) => request(`/api-data/user/province/count/get/${deptId}`, params, opts);
// 查询用户类型分布
export const getUserType = (deptId, params, opts) => request(`/api-data/user/type/count/get/${deptId}`, params, opts);
// 查询行为统计
export const getBehavior = (deptId, params, opts) => request(`/api-data/behavior/count/get/${deptId}`, params, opts);
// 查询班级活跃度TOP统计
export const geClassActivity = (params, opts) => request('/api-data/class/liveness/count/list', params, { ...opts, method: 'post' });
// 查询用户活跃度TOP统计
export const getUserActivity = (params, opts) => request('/api-data/user/liveness/count/list', params, { ...opts, method: 'post' });

//==============================班课统计======================================
//更新数据
export const updataDatacount = (params, opts) => request('/api-data/datacount/update', params, { ...opts, method: 'post' });
// 查询机构下所有班级列表
export const getClassInfoList = (params, opts) => request('/api-course/class/getClassInfoList', params, { ...opts, method: 'post' });
// 获取班级下学员列表
export const getUserInfo = (params, opts) => request('/api-course/class/getUserInfo', params, { ...opts, method: 'post' });
// 班级人数
export const getClassNum = (courseId, classId, params, opts) => request('/api-data/ZB/getStudent/'+courseId+'/'+classId, params, opts);
// 课程及小组进度
export const getCourseProgress = (params, opts) => request('/api-eval/ZB/qry-team-progress', params, { ...opts, method: 'post' });
// 最近学习人数
// export const getLearningNum = (params, opts) => request('/api-data/staUserLearnRecord/teacher', params, { ...opts, method: 'post' });
export const getLearningNum = (params, opts) => request('/api-data/ZB/get/learnNum', params, { ...opts, method: 'post' });
// 班级讨论详情
// export const getDiscussData = (courseId, classId, params, opts) => request('/api-data/staUserDiscuss/teacher/class/'+courseId+'/'+classId, params, opts);
export const getDiscussData = (courseId, classId, params, opts) => request('/api-data/ZB/get/class/discuss/'+courseId+'/'+classId, params, opts);
// 个人讨论详情
export const getOwnDiscussData = (courseId, classId, params, opts) => request('/api-study/ZB/get/teacher/discuss/'+courseId+'/'+classId, params, opts);
// 分岗位正确统计率(组)
export const getPostDataTeam = (params, opts) => request('/api-eval/ZB/qry-team-post-rate', params, { ...opts, method: 'post' });
// 分小组正确统计率
export const getGroupAccuracy = (params, opts) => request('/api-eval/ZB/qry-team-rate', params, { ...opts, method: 'post' });
// 排行榜
export const getGroupComprehensiveStrength = (params, opts) => request('/api-eval/ZB/qry-rate-sort', params, { ...opts, method: 'post' });
// 笔记详情
export const getNoteData = (courseId, classId, params, opts) => request('/api-data/ZB/get/student/note/'+courseId+'/'+classId, params, opts);
// 课程进度
export const getClassProgress = (courseId, classId, params, opts) => request('/api-data/ZB/get/course/progress/'+courseId+'/'+classId, params, opts);
// 分岗位正确统计率
export const getPostData = (params, opts) => request('/api-eval/ZB/qry-post-statistics', params, { ...opts, method: 'post' });
// 分学生正确统计率
export const getStudentAccuracy = (params, opts) => request('/api-eval/ZB/qry-user-rate', params, { ...opts, method: 'post' });
// 测验折线图
export const getTestData = (courseId, classId, params, opts) => request('/api-data/ZB/get/student/examTest/'+courseId+'/'+classId, params, opts);
// 资源进度
export const getSourceProgress = (courseId, classId, params, opts) => request('/api-data/ZB/get/course/progress/type/'+courseId+'/'+classId, params, opts);
// 班级进度详情
export const getCourseProgressList = (params, opts) => request('/api-data/ZB/get/course/progress/detail', params, { ...opts, method: 'post' });
// 获取讨论列表
export const getDiscussList = (params, opts) => request('/api-data/ZB/get/class/discuss/detail', params, { ...opts, method: 'post' });
// 获取详细进度
export const getDetailProgress = (courseId, classId, userId, params, opts) => request('/api-data/ZB/teacher/course/type/'+courseId+'/'+classId+'/'+userId, params, opts);
// 获取笔记列表
export const getNoteList = (params, opts) => request('/api-data/ZB/get/student/note/sort', params, { ...opts, method: 'post' });
// 查询最近学习人数（日周年）
export const recentLearningNum = (params, opts) => request('/api-data/learn/count/queryList', params, { ...opts, method: 'post' });
// 学习时长统计-教师
export const getLearnTimeTeacher = (courseId, classId, params, opts) => request('/api-study/ZB/teacher/getLearn/'+courseId+'/'+classId, params, opts);
// 学习时长统计-学生
export const getLearnTimeStudent = (courseId, classId, userId, params, opts) => request('/api-study/ZB/student/getLearn/'+courseId+'/'+classId+'/'+userId, params, opts);
// 获取所有课程
export const getAllCourse = (deptId, params, opts) => request('/api-course/course/selectAll/'+deptId, params, opts);


export const FindStationBySubjectId = (params, opts) => request(`/api-resource/station/${params}`, opts);
export const editNote = (params, opts) => request('/api-study/stuNote', params, { ...opts, method: 'put' });
//删除笔记
export const deleteNote = (params, opts) => request("/api-study/stuNote?id="+params.id, params, { ...opts, method: "delete" });

// 教师整体统计-页面数据埋点
export const pageLearningTime = ( params) => request('/api-data/time/addTime', params, {method: 'post'});



// WEBPACK FOOTER //
// ./src/api/HNstatisticsApi.js